import React, { PropsWithChildren } from 'react';

const PrintableWrapper = React.forwardRef<HTMLDivElement, PropsWithChildren>(
  ({ children }, ref) => (
    <div className="landscape-ready-container" ref={ref}>
      {children}
    </div>
  ),
);

PrintableWrapper.displayName = 'PrintableWrapper';

export default PrintableWrapper;
